const EVENTS = [
  'change',
  'input',
  'cut',
  'paste',
  'drop',
  'keydown',
  'resize',
];

export default {
  mounted(el) {
    el._resizeCallback = () => {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
      if (document.activeElement === el) {
        el.blur();
        el.focus();
      }
    };

    EVENTS.forEach(eventName => {
      el.addEventListener(eventName, el._resizeCallback, false);
    });
    window.addEventListener('resize', el._resizeCallback, false);
    el._resizeCallback();
  },
  beforeUnmount(el) {
    EVENTS.forEach(eventName => {
      el.removeEventListener(eventName, el._resizeCallback);
    });
    window.removeEventListener('resize', el._resizeCallback);
  },
};
